import { ROUTES } from '@celito.clients/enums';
import { useEntraRoles } from '@celito.clients/hooks';
import { Navigate, Outlet } from 'react-router';

/** Tenant-product routes are unavailable to platform-only SuperAdmins. */
export const TenantAccessGuard = () => {
  const { isSuperAdmin } = useEntraRoles();

  if (isSuperAdmin) {
    return <Navigate replace to={`/${ROUTES.TENANT_MANAGEMENT}`} />;
  }

  return <Outlet />;
};
